module.exports = "/_next/static/images/6-ad73d4020f90598e71352d4e663012be.gif";